import { render, staticRenderFns } from "./kuran-title.vue?vue&type=template&id=8bc57bb4&scoped=true&"
import script from "./kuran-title.vue?vue&type=script&lang=js&"
export * from "./kuran-title.vue?vue&type=script&lang=js&"
import style0 from "./kuran-title.vue?vue&type=style&index=0&id=8bc57bb4&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc57bb4",
  null
  
)

export default component.exports